import {NgModule} from '@angular/core';
import {DuplicateCheckService} from "~features/create-customer/duplicate-check.service";
import {DuplicateCheckComponent} from "~features/create-customer/components/duplicate-check/duplicate-check.component";
import {LeaveConfirmationComponent} from "~features/create-customer/components/leave-confirmation/leave-confirmation.component";
import {CreateCustomerComponent} from "~features/create-customer/pages/create-customer.component";
import {ModalModule} from "~shared/components/elements/modal.module";
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {FormValidationModule} from "~core/components/form-validation/form-validation.module";
import {FormFieldsModule} from "~shared/components/form-fields/form-fields.module";
import {ButtonsModule} from "~shared/components/buttons/buttons.module";
import {DirectivesModule} from "~shared/directives/directives.module";


/**
 * Module for customer overview section
 */
@NgModule({
  declarations: [
    CreateCustomerComponent,
    LeaveConfirmationComponent,
    DuplicateCheckComponent
  ],
  exports: [
    CreateCustomerComponent,
    LeaveConfirmationComponent,
    DuplicateCheckComponent
  ],
  providers: [
    DuplicateCheckService
  ],
  imports: [
    CommonModule,
    ModalModule,
    ReactiveFormsModule,
    FormValidationModule,
    FormFieldsModule,
    ButtonsModule,
    FormsModule,
    DirectivesModule,
  ]
})
export class CreateCustomerModule {
}
